import { useForm } from 'react-hook-form'

import { logisticFilialsApi } from 'redux/services/logistic-filial'
import { CreateLogisticFilial } from 'redux/services/logistic-filial/types'

import { AppButton } from 'components/AppButton'
import AppDatePicker from 'components/AppDatePicker/AppDatePicker'
import { AppModal } from 'components/AppModal'
import { AppSelect } from 'components/AppSelect'
import { TextField } from 'components/TextField'
import { TextFieldPhone } from 'components/TextFieldPhone'

import { CART_TYPES, URGENCY_TYPES } from 'constants/common'
import { CartType } from 'models/common'
import { LogisticCartUrgency } from 'models/logistic_cart'

import styles from './Create.module.scss'

interface Props {
  onClose: () => void
}
export function CreateLogisticCartModal({ onClose }: Props) {
  const { data: branches = [] } =
    logisticFilialsApi.useGetLogisticFilialsBranchesQuery()
  const {
    watch,
    register,
    clearErrors,
    setValue,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<CreateLogisticFilial>()
  const [submit, submitState] =
    logisticFilialsApi.useCreateLogisticFilialMutation()

  function onSubmit(values: CreateLogisticFilial) {
    submit(values)
      .unwrap()
      .then(() => {
        onClose()
      })
      .catch(err => {
        try {
          Object.entries(err.data.errors).forEach(([key, messages]) =>
            setError(key as keyof CreateLogisticFilial, {
              type: 'custom',
              message: Array.isArray(messages) ? messages[0] : messages,
            }),
          )
        } catch (error) {
          console.error(error)
        }
      })
  }

  return (
    <AppModal onClose={onClose} title={`Создание`}>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.container}>
        <TextField
          {...register('client_full_name', {
            required: 'Обязательное поле',
          })}
          required
          label="ФИО клиента"
          withError
          error={errors.client_full_name}
        />
        <TextFieldPhone
          withError
          onChangePhone={phone => {
            setValue('phone', phone.formattedPhone)
            clearErrors('phone')
          }}
          value={watch('phone')}
          error={errors.phone}
        />
        <AppSelect
          label="Тип"
          text={watch('cart_type') ? CART_TYPES[watch('cart_type')] : ''}
          onChangeValues={values => {
            if (values[0]) {
              setValue('cart_type', values[0] as CartType)
              clearErrors('cart_type')
            }
          }}
          required
          list={Object.entries(CART_TYPES).map(([value, title]) => ({
            title,
            value,
          }))}
          withError
          error={errors.cart_type}
        />
        <TextField
          required
          value={watch('pan')}
          onChange={e => {
            setValue(
              'pan',
              e.currentTarget.value.replace(/\D/g, '').slice(0, 4),
            )
            clearErrors('pan')
          }}
          label="ПАН Карты"
          withError
          error={errors.pan}
        />
        <AppDatePicker
          required
          type="date"
          onchange={e => {
            setValue('date_embossment', e)
            clearErrors('date_embossment')
          }}
          value={watch('date_embossment')}
          label="Дата эмбоссирования"
          withError
          error={errors.date_embossment}
        />
        <TextField
          {...register('comment')}
          label="Комментарий"
          withError
          error={errors.comment}
        />
        <AppSelect
          label="Филиал/СК"
          text={branches.find(b => b.id === watch('branch'))?.name || ''}
          onChangeValues={values => {
            if (values[0]) {
              setValue('branch', values[0])
              clearErrors('branch')
            }
          }}
          list={branches.map(b => ({
            title: b.name,
            value: b.id,
          }))}
          required
          withError
          error={errors.branch}
        />
        <AppSelect
          label="Степень срочности"
          text={URGENCY_TYPES[watch('degree_urgency')!] || ''}
          onChangeValues={values => {
            if (values[0]) {
              setValue('degree_urgency', values[0] as LogisticCartUrgency)
              clearErrors('degree_urgency')
            }
          }}
          list={Object.entries(URGENCY_TYPES).map(([value, title]) => ({
            title,
            value,
          }))}
          required
          withError
          error={errors.cart_type}
        />
        <AppButton disabled={submitState.isLoading} type="submit">
          Создать
        </AppButton>
      </form>
    </AppModal>
  )
}
